// src/services/couponService.js
import { apiService } from './api';

export const couponService = {
  /**
   * Récupère les coupons pour l'admin avec filtres optionnels
   * @param {string} offerId - ID de l'offre (optionnel)
   * @param {string} status - Statut des coupons (optionnel)
   * @returns {Promise} Données des coupons avec statistiques
   */
  async getAdminCoupons(offerId = null, status = null) {
    const params = new URLSearchParams();
    
    if (offerId) params.append('offerId', offerId);
    if (status) params.append('status', status);
    
    const queryString = params.toString();
    const url = `/coupons/admin${queryString ? `?${queryString}` : ''}`;
    
    const response = await apiService.get(url);
    console.log('Coupons data:', response.data);
    return response.data;
  }
};